import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { GetCerteficate, UpdateCerteficate, UpdateCerteficateProfile } from '../../store/certeficate/actions';
import { CheckUser } from '../../store/users/actions';
import { Button } from '../../test/components/ui';
import { ChangeFio } from '../modals';
import { IconCry } from '../svgs/IconCry';
import { Loader } from '../ui/Loader';
import * as Styles from './styles';
import { FormCerteficate, IFormValues } from './FormCerteficate';

interface Props {}

export const CertificateMed: React.FC<Props> = () => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isModal, setIsModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { Sockets, Users, Certeficate, FinalTest } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const generateCertificate = () => {
    if (!Sockets.event || !Users.user) return null;
    let fio_ua = Users.user.fio;
    if (!isEdit && Certeficate.data?.entity?.fio_ua && Users.user.fio.length < Certeficate.data.entity.fio_ua.length) {
      fio_ua = Certeficate.data.entity.fio_ua;
    }
    setLoading(true);
    dispatch(
      UpdateCerteficate.request({
        data: {
          event_id: Sockets.event.absnum,
          fio_ua,
        },
        callBack: (succ, data) => {
          if (succ && data.cert_pdf && data.message === 'ok' && Sockets.event) {
            dispatch(
              GetCerteficate.request({
                data: { event_id: Sockets.event.absnum },
                callBack: () => {
                  window.open(data.cert_pdf);
                },
              })
            );
          } else {
            setLoading(false);
          }
        },
      })
    );
  };

  const handleChange = (values: IFormValues, callback: (success: boolean, message?: string) => void) => {
    if (!Sockets.event) return null;
    if (loading) return null;

    setLoading(true);
    dispatch(
      UpdateCerteficateProfile.request({
        data: {
          event_id: Sockets.event.absnum,
          ...values,
        },
        callBack: (succ, data) => {
          if (!succ && typeof data === 'string') {
            callback(succ, data);
          }
          setLoading(false);
        },
      })
    );
  };

  if (Certeficate.error)
    return (
      <Styles.ModalBodyS>
        <h4 style={{ textAlign: 'center' }}>{Certeficate.error}</h4>
      </Styles.ModalBodyS>
    );

  if (!Sockets.event || !Certeficate.data) return null;

  if (Certeficate.error)
    return (
      <Styles.ModalBodyS>
        <h4 style={{ textAlign: 'center' }}>Виникла помилка</h4>
      </Styles.ModalBodyS>
    );

  if (FinalTest.data?.endDate && new Date(FinalTest.data?.endDate) < new Date() && !Certeficate.data.certeficate?.is_done)
    return (
      <Styles.WrapMessage>
        <h4>
          Нам дуже прикро, але Ви не встигли вчасно пройти фінальний тест відповідно до вимог Центру тестування МОЗ. Через це ми не можемо надати Вам
          сертифікат про нарахування балів БПР
        </h4>
      </Styles.WrapMessage>
    );

  if (new Date(Sockets.event.dateStart) > new Date())
    return (
      <Styles.ModalBodyS>
        <h4>Вітаю! Персональний сертифікат, що підтверджує участь у події буде доступний Вам після початку заходу та проходження фінального тесту</h4>
      </Styles.ModalBodyS>
    );
  if (!Certeficate.data.certeficate?.is_done)
    return (
      <Styles.ModalBodyS>
        <h4>Вітаю! Персональний сертифікат, що підтверджує участь у події буде доступний Вам після проходження фінального тесту</h4>
      </Styles.ModalBodyS>
    );
  if (!Certeficate.data?.certeficate?.is_profile && Certeficate.data?.certeficate?.is_done) {
    return (
      <FormCerteficate
        data={{
          workPlace: Users.user?.company,
          email: Users.user?.email,
          phone: Users.user?.phone,
          education: '',
          position: '',
          dateBirth: '',
        }}
        title={'Дані для отримання сертифіката'}
        description={
          'Через нові вимоги МОЗ до сертифікатів, які надають право медикам отримати бали БПР, ми змушені попросити Вас вказати додаткові дані, інакше, ми не зможемо подати сертифікат на реєстрацію.'
        }
        handleSubmit={handleChange}
      />
    );
  }
  if (!Certeficate.data?.entity || Certeficate.data?.entity.message !== 'ok')
    return (
      <Styles.ModalBodyS>
        <Styles.WrapText>
          Прикро <IconCry />
          <br /> Сталась помилка. Ваш сертифікат не знайдено в Єдиному реєстрі документів про підвищення кваліфікації. Зверніться, будь ласка, в
          підтримку за номером 0800 21 38 38
        </Styles.WrapText>
      </Styles.ModalBodyS>
    );
  if (Certeficate.data.entity.cert_pdf && Number(Certeficate.data.entity.is_change) > 0)
    return (
      <Styles.ModalBodyS style={{ textAlign: 'center' }}>
        <h4>Сертифікат можете скачати за даним посиланням</h4>
        <a href={Certeficate.data.entity.cert_pdf} target="_blank" rel="noreferrer" style={{ color: '-webkit-link', textDecoration: 'underline' }}>
          {Certeficate.data.entity.cert_pdf}
        </a>
      </Styles.ModalBodyS>
    );
  return (
    <>
      <Styles.ModalBodyS style={{ textAlign: 'center' }}>
        <h4>Перевірте правильність написання Вашого імені, саме так буде вказано в сертифікаті.</h4>
        <h2 style={{ textAlign: 'center' }}>{Users.user?.fio}</h2>
      </Styles.ModalBodyS>
      <Styles.ModalFooterS>
        <Styles.WrapBtn>
          <Button onClick={() => setIsModal(true)} title="Є помилка" />
          <Button onClick={generateCertificate} title="Все вірно" />
        </Styles.WrapBtn>
      </Styles.ModalFooterS>
      {loading && <Loader />}
      {isModal && (
        <ChangeFio
          changeHandler={() => setIsEdit(true)}
          closeHandler={() => {
            setIsModal(false);
            Sockets.event && dispatch(CheckUser.request({ data: { event_id: Sockets.event.absnum } }));
          }}
        />
      )}
    </>
  );
};
